import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Popover from '@material-ui/core/Popover';

export const FilterPopover = styled(Popover)`
    &.MuiPopover-root {
        z-index: 10000 !important;
    }
    & .MuiPaper-root {
        top: ${({ top }) => (top ? `${top} !important` : '141px !important')};
        right: ${({ right }) => `${right} !important`};
        left: ${({ left }) => `${left} !important`};
    }
    & .MuiPopover-paper{
        transition: all 100ms ease-in-out !important;
    }

    ${media.mobileDevice`

        & .MuiPaper-root{
            right: 0 !important;
            top: 0 !important;
            left:0 !important;
            margin-left:0 !important;
        }
        & .MuiPopover-paper{
            max-width: 100vw;
            max-height: 100vh;
            transition: all 100ms ease-in-out !important;
        }
    `}
`;
